import {computed} from 'vue';
import {useSettingsStore} from '@core/store/SettingsStore';

export function useThemeColors() {
  const settingsStore = useSettingsStore();

  const isDark = computed(() => settingsStore.darkModeEnabled);
  const colors = computed(() => {
    const mode = isDark.value ? 'dark' : 'light';
    return settingsStore.styles[mode];
  });

  return {
    isDark,
    colors,
  };
}
